import {Pipe, PipeTransform} from '@angular/core';
import {format} from 'date-fns';
import {parseToDate} from '../../shared/utils';
import fi from 'date-fns/locale/fi';
import {StateService} from '../../shared/state/state.service';

@Pipe({
  name: 'qmDateFormat'
})
export class QmDateFormatPipe implements PipeTransform {
  constructor(private state: StateService) {
  }
  transform(value: Date | string | number, form: string): string {
    if (this.state.getPartOfState('settingsState').language === 'fi') {
      return format(parseToDate(value), form, {locale: fi});
    } else {
      return format(parseToDate(value), form);
    }
  }
}
